import { useState, useEffect } from "react"

export const useFilterTreeData = (initialTreeData, searchString) => {
    const [treeData, setTreeData] = useState(initialTreeData);
    const [filteredTreeData, setFilteredTreeData] = useState([]);

    useEffect(() => {
        setTreeData(initialTreeData);
    }, [initialTreeData]);

    useEffect(() => {
        if (searchString && treeData && treeData.length > 0) {
            let fTreeData = [];

            treeData.forEach(t => {
                if (t.text.toUpperCase().startsWith(searchString) && t.droppable === false) {
                    // Only add the item if it doesn't already exist in fTreeData
                    if (!fTreeData.some(item => item.id === t.id)) {
                        const tNode = {
                            parent: 0,
                            text: t.text,
                            id: t.id,
                            droppable: t.droppable,
                            data: {
                                idx: t.idx
                            }
                        };

                        fTreeData.push(tNode);
                    }
                }
            });

            setFilteredTreeData(fTreeData);
        } else {
            setFilteredTreeData(treeData);
        }
    }, [searchString, treeData]);

    return filteredTreeData;
}
